const subscribers = {}

export const on = (eventName, callback) => {
  subscribers[eventName] = subscribers[eventName] || [];
  subscribers[eventName] = [...subscribers[eventName], callback];

  return () => {
    subscribers[eventName] = subscribers[eventName].filter((subscribedCallback) => callback !== subscribedCallback)
  };
};

export const trigger = (eventName, payload) => {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => callback(payload));
  }
};
